import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
  s3Location?: string;
};

type PostLoginBody = {
  email: string;
  password: string;
};
type queryUser = {
  page: number;
  search: string;
};
export const classApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllForms: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        createdBy?: number;
        contentType?: number;
        isDelete?: boolean;
        status?: number;
        userId?: string;
      }
    >({
      query: ({
        page,
        search,
        userId,
        createdBy,
        contentType,
        status,
        isDelete,
      }) => {
        let url = `${END_POINTS.getAllForms}?page=${page}${
          createdBy ? `&createdBy=${createdBy}` : ""
        }${userId ? `&userId=${userId}` : ""}${
          contentType ? `&contentType=${contentType}` : ""
        }${status ? `&status=${status}` : ""}${
          search ? `&search=${search}` : ""
        }${isDelete ? `&isDelete=${isDelete}` : ""}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getFormsById: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getFormsById}/${id}/`,
        method: "GET",
      }),
    }),

    // getSubjectList: builder.query<
    //   CommonResponseType & { data: any },
    //   { tutorId: string }
    // >({
    //   query: ({ tutorId }) => ({
    //     url: `${END_POINTS.getSubjectList}?tutorId=${tutorId}`,
    //     method: "GET",
    //   }),
    // }),
    updateFormsMulti: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.updateForms}`,
        method: "PUT",
        body,
      }),
    }),
    updateForms: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateForms}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteByIdForm: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteByIdForm}/${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllFormsQuery,
  useLazyGetFormsByIdQuery,
  useLazyDeleteByIdFormQuery,
  useUpdateFormsMutation,
  useUpdateFormsMultiMutation,
} = classApi;
